const actions = {
  SET_STATE: 'floorplan/SET_STATE',
  SET_FLOOR_PLAN: 'floorplan/SET_FLOOR_PLAN'
}

export default actions
